var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-switch",class:[
    `app-switch--${_vm.size}`,
    {
      'app-switch--light': _vm.lightMode,
      'app-switch--label-left': _vm.labelLeft,
      'app-switch--disabled': _vm.disabled,
      'app-switch--on': _vm.value,
      'app-switch--square': _vm.square,
    },
  ]},[_c('v-switch',{staticClass:"app-switch__ctl",attrs:{"input-value":_vm.value,"disabled":_vm.disabled,"loading":_vm.loading ? 'primary' : false,"dense":_vm.size !== 'md',"color":"primary","inset":"","ripple":false,"hide-details":""},on:{"change":function($event){return _vm.$emit('input', !!$event)}}}),(_vm.$slots.default)?_c('span',{staticClass:"app-switch__label",on:{"click":_vm.toggle}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }